// Shared quantity +/- stepper, reused unchanged by every purchase surface:
// PDP (sections/main-product.liquid), collection product cards
// (snippets/collection-product-card.liquid - also powers the homepage
// carousel/New Arrivals/Best Seller via that same snippet), and Featured
// Product (sections/featured-product.liquid, including its Pack of 2 offer
// picker). Scoped per [data-quantity-selector] root (markup:
// snippets/quantity-selector.liquid) - each root owns its own submitted
// <input name="quantity" data-quantity-input>, so quantity always means
// "how many of the currently selected variant", never a separate value.
//
// Also owns the ONE shared implementation of Add to Cart button updates
// (window.Velo.refreshAddToCartText): a static "Add to Cart" label
// (data-add-to-cart-text - NEVER contains quantity wording) plus a separate
// final-price span (data-button-final-price) and, only when a discount/
// compare-at applies, a struck-through original-price <s> (data-button-
// original-price). Driven by the closest form's [data-add-to-cart] button
// data-price/data-compare-at-price (the currently selected variant's own
// price, in cents, kept in sync by each surface's own variant-resolution
// script - product-form.js, collection-product-card.js, pack-offer-
// picker.js) via window.VeloPricing.calculate() (assets/velo-pricing.js) -
// the ONE shared pricing engine every surface consumes instead of
// duplicating this math. This same function also syncs the main price
// display above the options (data-price/data-card-price/data-featured-
// price + their compare-at counterparts), the submitted quantity input's
// physical value, and, only when a Pack of N option is selected, the
// physical-units helper text (data-pack-unit-summary) - so main price,
// button price, and cart payload can never disagree.
//
// The FIXED "Buy 2 and save X" marketing message (data-pack-promo-message,
// snippets/collection-product-card.liquid) is rendered once, server-side,
// from the real Single price + the "2" key of custom.volume_pricing, and is
// intentionally NEVER touched by this file - it must read the same
// regardless of quantity/variant interaction. data-pack-unit-summary is a
// completely separate, dynamic element for that reason.
window.Velo = window.Velo || {};

// DISPLAYED vs PHYSICAL quantity
// ------------------------------
// "Pack of N" is a STOREFRONT PRICING OPTION ONLY - it is never submitted to
// Shopify as its own variant/SKU. Every surface always submits the product's
// SINGLE variant; selecting "Pack of 2" only multiplies the quantity. So the
// stepper carries two numbers:
//
//   displayed quantity - what the customer sees/steps ("how many Packs"),
//     stored on the submitted input as data-display-quantity.
//   physical quantity  - displayed x packMultiplier, stored as the submitted
//     input's own .value, i.e. EXACTLY what /cart/add.js receives.
//
// Keeping the physical number in .value (instead of multiplying at submit
// time) means every submit path - the native FormData(form) add-to-cart, the
// Apple Pay CTA, and any future one - is automatically correct without each
// one re-deriving the multiplier.
//
// packMultiplier is read from [data-add-to-cart]'s data-pack-multiplier,
// which each surface's variant-resolution script keeps in sync alongside
// data-price/data-is-single-variant.
window.Velo.getPackMultiplier = function (scope) {
  if (!scope) return 1;
  var btn = scope.querySelector('[data-add-to-cart]');
  var multiplier = btn ? parseInt(btn.dataset.packMultiplier, 10) : 1;
  return multiplier > 1 ? multiplier : 1;
};

// Increment size for the +/- stepper AND the minimum valid displayed
// quantity (you can never step below one increment). Defaults to 1 (every
// normal surface: PDP single variant, collection cards, Pack of 2 offer
// picker). assets/pack-builder.js sets [data-add-to-cart]'s
// data-quantity-step to the SMALLEST pack tier's piece count (fixed,
// regardless of which tier is currently active) so the "QUANTITY" stepper
// always counts real total pieces in the same, predictable increment,
// instead of an ambiguous separate "number of packs" scale that silently
// multiplied the mix total shown above it.
window.Velo.getQuantityStep = function (scope) {
  if (!scope) return 1;
  var btn = scope.querySelector('[data-add-to-cart]');
  var step = btn ? parseInt(btn.dataset.quantityStep, 10) : 1;
  return step > 1 ? step : 1;
};

window.Velo.getDisplayQuantity = function (scope) {
  var input = scope && scope.querySelector('[data-quantity-input]');
  if (!input) return 1;
  var qty = parseInt(input.dataset.displayQuantity, 10);
  // First run against server-rendered markup: data-display-quantity has not
  // been written yet and .value is still the (unmultiplied) initial 1.
  if (!(qty > 0)) qty = parseInt(input.value, 10);
  return qty > 0 ? qty : 1;
};

window.Velo.getPhysicalQuantity = function (scope) {
  return window.Velo.getDisplayQuantity(scope) * window.Velo.getPackMultiplier(scope);
};

// Writes both numbers plus the visible stepper state. Safe on surfaces with no
// visible stepper (collection cards render only the hidden quantity input).
window.Velo.setQuantity = function (scope, displayQty) {
  var input = scope && scope.querySelector('[data-quantity-input]');
  if (!input) return 1;
  var qty = Math.max(1, parseInt(displayQty, 10) || 1);
  input.dataset.displayQuantity = String(qty);
  input.value = String(qty * window.Velo.getPackMultiplier(scope));
  var root = input.closest('[data-quantity-selector]');
  if (root) {
    var displaySpan = root.querySelector('[data-qty-display]');
    var decreaseBtn = root.querySelector('[data-qty-decrease]');
    if (displaySpan) displaySpan.textContent = String(qty);
    if (decreaseBtn) decreaseBtn.disabled = qty <= window.Velo.getQuantityStep(scope);
  }
  return qty;
};

// Re-derives the physical .value from the unchanged displayed quantity - call
// after data-pack-multiplier changes (Single <-> Pack of N switch). The
// displayed quantity intentionally PERSISTS across that switch: the submitted
// variant is the same Single SKU either way, so nothing can go stale.
window.Velo.syncQuantity = function (scope) {
  return window.Velo.setQuantity(scope, window.Velo.getDisplayQuantity(scope));
};

// Resets a scope's quantity back to 1 (displayed and physical). Used by
// variant-resolution scripts when the resolved SINGLE variant genuinely
// changes (e.g. a different colour), so a quantity chosen for one SKU never
// carries over to another. Does not itself call refreshAddToCartText - the
// caller is expected to do so after also syncing data-price/
// data-is-single-variant/data-pack-multiplier.
window.Velo.resetQuantitySelector = function (scope) {
  window.Velo.setQuantity(scope, 1);
};

window.Velo.refreshAddToCartText = function (scope) {
  if (!scope) return;
  var btn = scope.querySelector('[data-add-to-cart]');
  var labelEl = scope.querySelector('[data-add-to-cart-text]');
  var finalPriceEl = scope.querySelector('[data-button-final-price]');
  var originalPriceEl = scope.querySelector('[data-button-original-price]');
  var discountInfo = scope.querySelector('[data-volume-discount-info]');
  var packUnitEl = scope.querySelector('[data-pack-unit-summary]');
  if (!btn || !labelEl) return;

  // Always re-derive the submitted (physical) quantity first, so the input
  // POSTed to /cart/add.js can never lag behind the current pack multiplier -
  // including on the disabled/sold-out early return below.
  var displayQty = window.Velo.syncQuantity(scope);
  var packMultiplier = window.Velo.getPackMultiplier(scope);

  if (btn.disabled) {
    labelEl.textContent = labelEl.dataset.soldOutLabel || labelEl.textContent;
    if (finalPriceEl) finalPriceEl.classList.add('hidden');
    if (originalPriceEl) originalPriceEl.classList.add('hidden');
    if (discountInfo) discountInfo.classList.add('hidden');
    if (packUnitEl) packUnitEl.hidden = true;
    return;
  }

  if (labelEl.dataset.addLabel) labelEl.textContent = labelEl.dataset.addLabel;
  if (finalPriceEl) finalPriceEl.classList.remove('hidden');

  var priceCents = parseInt(btn.dataset.price, 10) || 0;
  var compareAtPriceCents = parseInt(btn.dataset.compareAtPrice, 10) || 0;
  var isSingle = btn.dataset.isSingleVariant === 'true';
  var volumePricing = null;
  if (isSingle && btn.dataset.volumePricing) {
    try {
      volumePricing = JSON.parse(btn.dataset.volumePricing);
    } catch (e) {
      volumePricing = null;
    }
  }

  var result = window.VeloPricing.calculate({
    selectedVariant: { id: btn.dataset.variantId, price: priceCents, compare_at_price: compareAtPriceCents },
    quantity: displayQty,
    packMultiplier: packMultiplier,
    isSingleVariant: isSingle,
    volumePricing: volumePricing
  });

  if (finalPriceEl) finalPriceEl.textContent = window.Velo.formatMoney(result.finalTotal);

  if (originalPriceEl) {
    originalPriceEl.classList.toggle('hidden', !result.hasDiscount);
    if (result.hasDiscount) originalPriceEl.textContent = window.Velo.formatMoney(result.originalTotal);
  }

  // "Volume discount applied" is ONLY for a real quantity-tier match
  // (custom.volume_pricing). A plain compare-at sale price is already shown
  // struck-through next to the main price and inside the button - repeating
  // it here at quantity 1 under a "volume discount" label is simply wrong.
  if (discountInfo) {
    var hasVolumeDiscount = result.hasDiscount && result.pricingMode === 'single_volume';
    discountInfo.classList.toggle('hidden', !hasVolumeDiscount);
    if (hasVolumeDiscount) {
      var originalEl = discountInfo.querySelector('[data-volume-discount-original]');
      var messageEl = discountInfo.querySelector('[data-volume-discount-message]');
      if (originalEl) originalEl.textContent = window.Velo.formatMoney(result.originalTotal);
      if (messageEl) messageEl.textContent = messageEl.dataset.message || '';
    }
  }

  // Dynamic pack-unit-summary ("N x Pack of 2 = M units") - shown whenever a
  // Pack of N option is selected (packMultiplier > 1), updates on every
  // quantity change. This is the customer's only cue that their cart line
  // will read "Single x M", since Pack of N is never a real cart line.
  // Completely separate from the fixed data-pack-promo-message, which this
  // function never touches.
  if (packUnitEl) {
    if (packMultiplier > 1) {
      var template = packUnitEl.dataset.packUnitTemplate || '';
      var unitsTemplate = packUnitEl.dataset.packUnitsTemplate || '';
      var unitsDual = packUnitEl.dataset.packUnitsDual || '';
      var units = result.physicalUnits;
      var unitsText = (units === 2 && unitsDual) ? unitsDual : unitsTemplate.replace('%N%', units);
      packUnitEl.textContent = template.replace('%QTY%', displayQty).replace('%UNITS%', unitsText);
      packUnitEl.hidden = false;
    } else {
      packUnitEl.hidden = true;
    }
  }

  // Main price display above the options - always the SAME total shown on
  // the button, never a static per-unit price left stale after a quantity
  // change. [data-collection-product-card]/[data-pack-offer-section] scope
  // the lookup to the current card/section (multiple can exist on one
  // page); PDP has neither wrapper and falls back to the whole document
  // (only one PDP purchase form exists per page).
  var outerRoot = scope.closest('[data-collection-product-card]') || scope.closest('[data-pack-offer-section]') || document;
  var mainPriceEl = outerRoot.querySelector('[data-card-price], [data-featured-price], [data-price]');
  var mainCompareAtEl = outerRoot.querySelector('[data-card-compare-at-price], [data-featured-compare-at], [data-compare-at-price]');
  if (mainPriceEl) mainPriceEl.textContent = window.Velo.formatMoney(result.finalTotal);
  if (mainCompareAtEl) {
    mainCompareAtEl.classList.toggle('hidden', !result.hasDiscount);
    if (result.hasDiscount) mainCompareAtEl.textContent = window.Velo.formatMoney(result.originalTotal);
  }
};

(function () {
  document.querySelectorAll('[data-quantity-selector]').forEach(function (root) {
    var quantityInput = root.querySelector('[data-quantity-input]');
    var decreaseBtn = root.querySelector('[data-qty-decrease]');
    var increaseBtn = root.querySelector('[data-qty-increase]');
    if (!quantityInput) return;

    var scope = root.closest('form') || root;

    // The stepper always moves the DISPLAYED quantity by one increment
    // (window.Velo.getQuantityStep - 1 on every normal surface, "one more
    // Pack" not "one more unit"; the pack-builder's own pack size when set);
    // setQuantity re-derives the submitted physical value from it.
    function step(direction) {
      var increment = window.Velo.getQuantityStep(scope);
      var qty = window.Velo.getDisplayQuantity(scope) + direction * increment;
      if (qty < increment) return;
      window.Velo.setQuantity(scope, qty);
      window.Velo.refreshAddToCartText(scope);
      // Lets a surface with its own derived UI (assets/pack-builder.js's
      // "N pieces (M x Tier)" hint) react to a quantity change the shared
      // stepper made directly - refreshAddToCartText only touches the
      // generic price/label elements this file already knows about.
      scope.dispatchEvent(new CustomEvent('velo:quantity-changed', { bubbles: true }));
    }

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        step(-1);
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        step(1);
      });
    }

    window.Velo.refreshAddToCartText(scope);
  });
})();
